import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { Group, Paper, Stack, Title } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import { WordsDiff } from "@/components/WordsDiff";
import { getEncounterClientDiagnoses } from "@/encounters/zod-schemas/encounter-answers";

const DxDiagnosesVersionDiff = ({
  currentVersion,
  previousVersion,
}: {
  currentVersion?: QuestionnaireResponse;
  previousVersion?: QuestionnaireResponse;
}) => {
  if (!currentVersion) return null;

  const currentAnswers = getEncounterClientDiagnoses(currentVersion);
  const previousAnswers = previousVersion ? getEncounterClientDiagnoses(previousVersion) : [];

  if (!currentVersion && !previousVersion) {
    return (
      <Paper p="md" withBorder>
        <Stack mb="lg">
          <Title order={3}>Diagnoses</Title>
        </Stack>
        <TextWrapper py="lg" c="gray.6" ta="center">
          No Diagnoses data has been recorded for this encounter.
        </TextWrapper>
      </Paper>
    );
  }

  return (
    <Paper p="md" withBorder>
      <Stack mb="lg">
        <Title order={3}>Diagnoses</Title>
      </Stack>
      <Group grow align="stretch">
        <Paper p="md" withBorder>
          <Stack>
            <Title mb="lg" order={4} c="gray.6">
              Previous
            </Title>
            {previousAnswers.map((diagnosis, index) => (
              <Stack gap="md" key={index}>
                <Stack gap="0">
                  <TextWrapper fw={600}>Diagnosis</TextWrapper>
                  <WordsDiff
                    showRemoved
                    previous={diagnosis.encounterDiagnosisCode?.display}
                    current={currentAnswers[index]?.encounterDiagnosisCode?.display}
                  />
                </Stack>
                <Stack gap="0">
                  <TextWrapper fw={600}>Notes</TextWrapper>
                  <WordsDiff
                    showRemoved
                    previous={diagnosis.encounterDiagnosisNotes}
                    current={currentAnswers[index]?.encounterDiagnosisNotes}
                  />
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Paper>
        <Paper p="md" withBorder>
          <Stack>
            <Title mb="lg" order={4} c="gray.6">
              Amended
            </Title>
            {currentAnswers.map((diagnosis, index) => (
              <Stack gap="md" key={index}>
                <Stack gap="0">
                  <TextWrapper fw={600}>Diagnosis</TextWrapper>
                  <WordsDiff
                    current={diagnosis.encounterDiagnosisCode?.display}
                    previous={previousAnswers[index]?.encounterDiagnosisCode?.display}
                  />
                </Stack>
                <Stack gap="0">
                  <TextWrapper fw={600}>Notes</TextWrapper>
                  <WordsDiff
                    current={diagnosis.encounterDiagnosisNotes}
                    previous={previousAnswers[index]?.encounterDiagnosisNotes}
                  />
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Paper>
      </Group>
    </Paper>
  );
};

export default DxDiagnosesVersionDiff;
